import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  text-align: center;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 8px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  min-height: 100%;\n  width: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  background-color: ", ";\n  border-radius: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      ", " {\n        background-color: ", ";\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  justify-content: space-around;\n  border-radius: ", ";\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as DateFns from 'date-fns/fp';
import React, { useCallback, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Select } from '../select/Select';
import { Input } from '../input/Input';
import * as DateUtils from './dateUtils';
import * as TimeUnit from './timeUnit';
var TimeWrapper = styled.div(_templateObject(), themeGet('input.borderRadius'), function (props) {
  return props.disabled && css(_templateObject2(), InputContainer, themeGet('input.disabled.backgroundColor'));
});
var InputContainer = styled.div(_templateObject3(), themeGet('input.backgroundColor'), themeGet('input.borderRadius'));
var StyledDivider = styled.span(_templateObject4(), themeGet('colors.transparent'));
var AMPMSelect = styled(Select)(_templateObject5());
var StyledInput = styled(Input)(_templateObject6(), themeGet('colors.transparent'));

var formatTime = function formatTime(time, unit) {
  switch (unit) {
    case TimeUnit.Units.HOUR_24:
      return time.toString().padStart(2, '0');

    case TimeUnit.Units.HOUR_12:
      return DateUtils.get12HourFrom24Hour(time).toString().padStart(2, '0');

    case TimeUnit.Units.MINUTE:
    case TimeUnit.Units.SECOND:
      return time.toString().padStart(2, '0');

    case TimeUnit.Units.MS:
      return time.toString().padStart(3, '0');

    default:
      throw Error('Invalid TimeUnit');
  }
};

var timeUnitOptions = [TimeUnit.ClockFormats.AM, TimeUnit.ClockFormats.PM].map(function (format) {
  return {
    name: format,
    value: format
  };
});
export var TimePicker = function TimePicker(_ref) {
  var date = _ref.date,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      minTime = _ref.minTime,
      maxTime = _ref.maxTime,
      useAmPm = _ref.useAmPm,
      disabled = _ref.disabled,
      isMobile = _ref.isMobile;
  var hourUnit = useAmPm ? TimeUnit.Units.HOUR_12 : TimeUnit.Units.HOUR_24;

  var _useState = useState(date || defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      currentDate = _useState2[0],
      setCurrentDate = _useState2[1];

  useEffect(function () {
    if (date && !DateFns.isEqual(date, currentDate)) {
      setCurrentDate(date);
    }
  }, [currentDate, date]);
  var timeInRange = DateUtils.getTimeInRange(currentDate, minTime, maxTime);
  var isPm = DateUtils.getIsPmFrom24Hour(timeInRange.getHours());

  var _useState3 = useState(isPm ? timeUnitOptions[1] : timeUnitOptions[0]),
      _useState4 = _slicedToArray(_useState3, 2),
      clockFormat = _useState4[0],
      setClockFormat = _useState4[1];

  var hourText = formatTime(timeInRange.getHours(), hourUnit);
  var minuteText = formatTime(timeInRange.getMinutes(), TimeUnit.Units.MINUTE);
  var updateTime = useCallback(function (time, unit) {
    var newDate = DateUtils.clone(currentDate);

    if (TimeUnit.isTimeUnitValid(unit, time)) {
      TimeUnit.setTimeUnit(unit, time, newDate, isPm);
    }

    if (!date) {
      setCurrentDate(newDate);
    }

    if (onChange && !DateUtils.isSameTime(date, newDate)) {
      onChange({
        target: {
          value: newDate
        }
      });
    }

    return newDate;
  }, [currentDate, date, isPm, onChange]); // select all in input when input on focus

  var handleInputFocus = useCallback(function (e) {
    e.target.select();
  }, []);

  var handleInputChange = function handleInputChange(unit) {
    return function (e) {
      var text = e.target.value;
      updateTime(parseInt(text, 10), unit);
    };
  };

  var handleAmPmChange = useCallback(function (format) {
    var value = format.value;

    if (clockFormat.value !== value) {
      var hour = DateUtils.convert24HourMeridiem(timeInRange.getHours(), value === TimeUnit.ClockFormats.PM);
      var newDate = updateTime(hour, TimeUnit.Units.HOUR_24);
      setClockFormat(format);
      setCurrentDate(newDate);

      if (onChange) {
        onChange({
          target: {
            value: newDate
          }
        });
      }
    }
  }, [clockFormat.value, timeInRange, updateTime, onChange]);
  var handleMobileTimeInputChange = useCallback(function (e) {
    var _e$target$value$split = e.target.value.split(':'),
        _e$target$value$split2 = _slicedToArray(_e$target$value$split, 2),
        hour = _e$target$value$split2[0],
        min = _e$target$value$split2[1];

    updateTime(parseInt(hour, 10), hourUnit);
    updateTime(parseInt(min, 10), TimeUnit.Units.MINUTE);
  }, [hourUnit, updateTime]);
  var currentTime = "".concat(hourText, ":").concat(minuteText);
  return isMobile ?
  /*#__PURE__*/
  React.createElement("input", {
    type: "time",
    value: currentTime,
    onChange: handleMobileTimeInputChange,
    disabled: disabled
  }) :
  /*#__PURE__*/
  React.createElement(TimeWrapper, {
    disabled: disabled
  },
  /*#__PURE__*/
  React.createElement(InputContainer, null,
  /*#__PURE__*/
  React.createElement(StyledInput, {
    width: 40,
    value: hourText,
    onFocus: handleInputFocus,
    onChange: handleInputChange(hourUnit),
    placeholder: "Hour",
    disabled: disabled
  }),
  /*#__PURE__*/
  React.createElement(StyledDivider, null, ":"),
  /*#__PURE__*/
  React.createElement(StyledInput, {
    width: 40,
    value: minuteText,
    onFocus: handleInputFocus,
    onChange: handleInputChange(TimeUnit.Units.MINUTE),
    placeholder: "Min",
    disabled: disabled
  })), useAmPm &&
  /*#__PURE__*/
  React.createElement(AMPMSelect, {
    width: 70,
    value: clockFormat,
    options: timeUnitOptions,
    onChange: handleAmPmChange,
    disabled: disabled
  }));
};
TimePicker.defaultProps = {
  defaultValue: new Date(0, 0, 0, 0, 0, 0, 0),
  maxTime: TimeUnit.getDefaultMaxTime(),
  minTime: TimeUnit.getDefaultMinTime(),
  useAmPm: false,
  isMobile: false
};